import { IApplicationState } from '../../types/redux';

export const selectFormDefaults = (state: IApplicationState) => state.calculator.initialFormState;
